// extracted by mini-css-extract-plugin
export default {"container":"pP-z","modal":"qP-z","dimensions":"rP-z","brandName":"sP-z","productName":"tP-z","labelValue":"uP-z","recipientEmail":"vP-z","recommendedFit":"wP-z","hiddenField":"xP-z"};